<template>
  <ul class="flex-list pl-0">
    <li>
      <v-btn
        v-if="showNotImplemented"
        disabled
        size="small"
        variant="text"
        icon="$favourite-star"
      />
    </li>
    <li>
      <v-btn v-if="showNotImplemented" disabled icon="$notes" size="small" variant="text" />
    </li>
    <li>
      <v-progress-circular v-if="hasProgress" :model-value="progressPercent" size="25" width="3">
        {{ progressPercent }}
      </v-progress-circular>

      <v-tooltip v-else location="bottom">
        <template #activator="{ props: activatorProps }">
          <v-btn
            v-bind="activatorProps"
            icon="mdi-content-copy"
            variant="text"
            :loading="copyInProgress"
            :disabled="!canCopyScenario"
            @click="() => handleCopyScenario()"
          />
        </template>
        <span>{{ $t('actions.copy') }}</span>
      </v-tooltip>
    </li>
    <ScenarioOptionDelete :scenario="scenario" />
  </ul>
</template>

<script>
import { ref } from 'vue';
import { includes, get } from 'lodash';
import jobapi from '@enums/jobapi';
import { usePermission } from '@/composables/use-permission';
import { useContextStore } from '@/stores/context';
import { useScenariosStore } from '@/stores/scenarios';
import { useSnackbarStore } from '@/stores/snackbar';

export default {
  props: {
    scenario: {
      required: true,
      type: Object,
    },
  },

  setup() {
    const { canCopyScenario } = usePermission();
    const { showNotImplemented } = useContextStore();
    const { showError, showSuccess } = useSnackbarStore();
    const { copyScenario, setSelectedScenario } = useScenariosStore();

    return {
      canCopyScenario,
      showNotImplemented,
      showError,
      showSuccess,
      copyScenario,
      setSelectedScenario,
    };
  },

  data() {
    return { copyInProgress: ref(false) };
  },

  computed: {
    copyScenarioJobStatus() {
      return get(this.scenario, 'jobs.copyScenario.status');
    },

    copyJobInProgress() {
      return includes(jobapi.jobInProgressStatuses, this.copyScenarioJobStatus);
    },

    progressPercent() {
      return get(this.scenario, 'jobs.copyScenario.progress');
    },

    hasProgress() {
      return this.copyJobInProgress && this.progressPercent > 0 && this.progressPercent < 100;
    },
  },

  watch: {
    progressPercent(newProgress) {
      // Reset the loading state when progress reaches 100%
      if (newProgress === 100) {
        this.copyInProgress = false;
      }
    },
  },

  methods: {
    async handleCopyScenario() {
      this.copyInProgress = true;
      this.setSelectedScenario(this.scenario);
      this.showSuccess(
        this.$t('notifications.copyScenario.starting', { name: this.scenario.name })
      );

      await this.copyScenario(this.scenario);
    },
  },
};
</script>
